module.exports = __webpack_public_path__ + "static/media/construccion.48a78daa.png";